export const sendCode = async ({ email }: { email: string }) => {
  const res = await fetch("/api/start-passwordless", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email })
  });

  if (!res.ok) {
    const body = await res.json();
    throw new Error(body.error || "Failed to send code");
  }
};

export const verifyCode = async ({ email, code }: { email: string; code: string }) => {
  const res = await fetch("/api/verify-passwordless", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, code })
  });

  if (!res.ok) {
    const body = await res.json();
    throw new Error(body.error || "Failed to send code");
  }

  const tokens = (await res.json()) as {
    access_token: string;
    id_token: string;
    scope: string;
    expires_in: number;
    token_type: string;
  };
  return tokens;
};

export const RETRY_TIMEOUT = 30 * 1000;
export const RETRY_LIMIT = 5;
